import {Component, OnInit} from "@angular/core";
import {select} from "@angular-redux/store";
import {ISelectedStock} from "../../../shared/redux-store/store-management/stock/stock.types";
import {Observable} from "rxjs/Observable";
import {ActivatedRoute, Router} from "@angular/router";
import {Stock} from "../../../shared/view-model/stock";
import {ReduxRouteService} from "../../../shared/redux-store/redux-route.service";
import {StockService} from "../../services/stock.service";
import {StockItem} from "../../../shared/view-model/store-management/stock-item.type";
import {ApolloQueryObservable} from "apollo-angular";
import {map, mergeMap} from "rxjs/operators";

@Component({
  selector: 'vb-stock-detail',
  templateUrl: './stock-detail.component.html',
  styleUrls: ['./stock-detail.component.css']
})
export class StockDetailComponent implements OnInit {

  @select('stock') state$: Observable<ISelectedStock>;
  stock$: ApolloQueryObservable<Stock>;
  variants$: ApolloQueryObservable<StockItem[]>;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private reduxRouteService: ReduxRouteService,
              private stockService: StockService) {
  }

  ngOnInit() {

    this.reduxRouteService.processRoute(this.route);

    this.stock$ = <ApolloQueryObservable<any>>this.state$.pipe(
      mergeMap(state => this.stockService.getStock(state.selectedStock))
    );

    this.variants$ = <ApolloQueryObservable<any>>this.stock$.pipe(
      mergeMap((stock: any) => this.stockService.getStockWithVariants(stock.cuid, stock.depot.cuid)),
      map(res => res.variants)
    );


  }

  selectVariant(stockCuid: string) {
    this.router.navigate(['../', stockCuid], {relativeTo: this.route})
  }


}



// WEBPACK FOOTER //
// ./src/app/store-management/stock/stock-detail/stock-detail.component.ts